import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

import {
    SalesIndentDetailCreateRequestDTO,
    SalesIndentDetailDeleteRequestDTO,
    SalesIndentDetailDTO,
    SalesIndentDetailUpdateRequestDTO,
    SalesIndentDetailReadByIdRequestDTO,
    SalesIndentDetailReadByIndentIdRequestDTO,
    SalesIndentDetailReadByIndentIdForImportRequestDTO,
    SalesIndentDetailUpsertBulkRequestDTO,
    SalesIndentDetailList
} from "./indent-detail.interface";

import {
    SalesIndentDetail_Create,
    SalesIndentDetail_Update,
    SalesIndentDetail_Delete,
    SalesIndentDetail_ReadAll,
    SalesIndentDetail_ReadById,
    SalesIndentDetail_ReadByIndentId,
    SalesIndentDetail_ReadByIndentIdForImport,
    SalesIndentDetail_UpsertBulk
} from "src/app/GlobalVariables";


@Injectable({ providedIn: 'root' })
export class SalesIndentDetailService {

    http = inject(HttpClient);


    /*** Create Sales Indent Detail */
    SalesIndentDetail_Create(data: SalesIndentDetailCreateRequestDTO): Observable<SalesIndentDetailDTO> {
        return this.http.post<SalesIndentDetailDTO>(SalesIndentDetail_Create, data);
    }


    /*** Update Sales Indent Detail */
    SalesIndentDetail_Update(data: SalesIndentDetailUpdateRequestDTO): Observable<SalesIndentDetailDTO> {
        return this.http.post<SalesIndentDetailDTO>(SalesIndentDetail_Update, data);
    }


    /*** Delete Sales Indent Detail */
    SalesIndentDetail_Delete(data: SalesIndentDetailDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(SalesIndentDetail_Delete, data);
    }


    /*** Read All Sales Indent Detail */
    SalesIndentDetail_ReadAll(): Observable<SalesIndentDetailDTO> {
        return this.http.get<SalesIndentDetailDTO>(SalesIndentDetail_ReadAll);
    }

    /*** Read By Id Sales Indent Detail */
    SalesIndentDetail_ReadById(data: SalesIndentDetailReadByIdRequestDTO): Observable<SalesIndentDetailDTO> {
        return this.http.post<SalesIndentDetailDTO>(SalesIndentDetail_ReadById, data);
    }

    /*** Read By Indent Id Sales Indent Detail */
    SalesIndentDetail_ReadByIndentId(data: SalesIndentDetailReadByIndentIdRequestDTO): Observable<SalesIndentDetailList> {
        return this.http.post<SalesIndentDetailList>(SalesIndentDetail_ReadByIndentId, data);
    }

    /*** Read By Indent Id For Import Sales Indent Detail */
    SalesIndentDetail_ReadByIndentIdForImport(data: SalesIndentDetailReadByIndentIdForImportRequestDTO): Observable<SalesIndentDetailList> {
        return this.http.post<SalesIndentDetailList>(SalesIndentDetail_ReadByIndentIdForImport, data);
    }

    /*** Upsert Bulk Sales Indent Detail */
    SalesIndentDetail_UpsertBulk(data: SalesIndentDetailUpsertBulkRequestDTO): Observable<SalesIndentDetailList> {
        return this.http.post<SalesIndentDetailList>(SalesIndentDetail_UpsertBulk, data);
    }
}